jQuery(function($) {
  function positionTimelineItems() {
    var $container = $('.container-timeline');
    var $items = $container.find('.mb-timeline-item');
    var gap = 40; // px between cards in the same column
    var leftColumnBottom = 0;
    var rightColumnBottom = 40; // Start the right column 40px lower
    var maxBottom = 0;

    // Reset styles for responsiveness
    $items.css({ position: '', top: '', left: '', right: '', transform: '' })
          .removeClass('left-column right-column');
    $container.css('height', '');

    // Mobile view: stack cards with line on left
    if (window.innerWidth <= 1024) {
      $items.css({ position: 'relative', top: '', left: '', right: '', transform: '' });
      $container.css('height', '');
      return;
    }

    // Desktop view: alternate between left and right column with 40px gap within each column
    $items.each(function(i) {
      var $item = $(this);
      var itemHeight = $item.outerHeight(true);

      if (i % 2 === 0) {
        // Left column
        $item.addClass('left-column');
        $item.css({
          position: 'absolute',
          top: leftColumnBottom + 'px',
        });
        leftColumnBottom += itemHeight + gap;
      } else {
        // Right column
        $item.addClass('right-column');
        $item.css({
          position: 'absolute',
          top: rightColumnBottom + 'px',
        });
        rightColumnBottom += itemHeight + gap;
      }

      maxBottom = Math.max(maxBottom, parseFloat($item.css('top')) + itemHeight);
    });

    // Set container height to fit all cards
    $container.css('height', (maxBottom + 40) + 'px');
  }

  // Handle popover functionality
  function setupPopoverHandlers() {
    // Handle click on either the popover container or directly on the eye icon
    $('.mb-timeline-popover, .mb-timeline-popover .fa-eye').on('click', function(e) {
      e.preventDefault();
      e.stopPropagation();

      // Get the popover container (might be the clicked element or its parent)
      var $popover = $(this).hasClass('mb-timeline-popover') ?
                    $(this) :
                    $(this).closest('.mb-timeline-popover');

      // Close any other open popovers
      $('.mb-timeline-popover').not($popover).removeClass('active');

      // Toggle this popover
      $popover.toggleClass('active');
    });

    // Close popover when clicking outside
    $(document).on('click', function(e) {
      if (!$(e.target).closest('.mb-timeline-popover').length) {
        $('.mb-timeline-popover').removeClass('active');
      }
    });

    // Prevent closing when clicking inside popover content
    $('.mb-timeline-popover-content').on('click', function(e) {
      e.stopPropagation();
    });
  }

  // Initial position
  positionTimelineItems();
  setupPopoverHandlers();

  // Reposition on resize
  $(window).on('resize', positionTimelineItems);

  // Reposition after images load (for accurate height calculations)
  $(window).on('load', positionTimelineItems);
});

